module.exports = __webpack_public_path__ + "static/media/search-not-found.017e06a8.svg";